import {calcUtmString, getUtmTestParameters} from "../../../../logic/setup/UtmParser";
import queryString from "query-string";
import {parseParameters} from "../../../../logic/setup/ParametersParser";
import {logCounter} from "../../../model/utils";
import {currentLang, getImpl, lgSetup} from "../../../../backend/LgSetup";
import {assertEqual, assertTrue} from "../../../../unittests/UnitTestHelper";
import {calculateDistances} from "../../../../logic_tmp/DistanceCalculator";
export async function testWhereGenerationByRegion() {
    let ret = await calcWhereByRegion("BADEN-WÜRTTEMBERG")
    if (currentLang === "ru")
    {
    assertTrue(ret.includes("Карлсруэ"))
    assertTrue(ret.includes("Хайльбронне"))
    }
}

export async function testLgHelper() {
    let str = getUtmTestParameters() + "&action=CIRCLE&lmKey=KOILIN_BELLACIAO"
    let data = {}
    let queryParams = queryString.parse(str)
    parseParameters(queryParams, data)
    let profile = {
        firstEntryPath: {
            circleKey: "GENERATORS",
            lmKey: "KOILIN_BELLACIAO"
        }
    }
    assertEqual("KOILIN_BELLACIAO", data.lmKey)
    setCyrcleEnv(data, profile)
    assertTrue(data.currentPathObj.circle !== undefined)
    assertTrue(data.currentPathObj.circle.concertObj !== undefined)
    assertEqual("Музыка во благо", calcNameOfConcert(data))
    assertEqual("METELICA", data.nextLmKey)
    assertTrue(!data.nextLmUrl.includes("undefined"))
    await prepareGeo(data)
    assertTrue(calcMotivationForNextLm(data).includes("Посмотрите еще один фрагмент этого концерта, о песне \"Вдоль по улице"))
    assertEqual("Посмотреть фрагмент \"Метелица\".", calcNextLmButtonName(data))
    assertTrue(calcNectLmUrl(data).includes("lg-metelica"))
    if (currentLang === "ru")
        assertTrue(calcWhere(data).includes("Штуттгарте"))
}

export async function prepareGeo(data) {
    await calcWhereByRegion(data["geoCode"]).then((dataStr) => {
        data.whereLoc = dataStr
    })
    await calculateDistances(data["geoCode"]).then((dataStr) => {
        data.geoData = dataStr
    })
}

export function setCyrcleEnv(data, profile) {
    if (data.currentPathObj === undefined) data.currentPathObj = {}
    data.currentPathObj.circle = lgSetup.circles[data.currentPath["circleKey"]]
    data.currentPathObj.circle.concertObj = lgSetup.concerts[data.currentPathObj.circle.concert]
    if (profile.firstEntryPath === undefined)
        throw Error("FirstEntryPath is empty!")
    let nextLmKey = calculateNextLmInCircle(profile,data.lmKey)
    data.nextLmKey = nextLmKey
    data.nextLm = lgSetup.lms[nextLmKey]
    data.nextLmUrl = calculateNextLmInCircleUrl(data, nextLmKey)
}

function getLmCircleParams(data, lmKey) {
    return getCommonParams(data) + "&lmKey=" + lmKey + "&circleKey=" + data.currentPath["circleKey"] + "&action=CIRCLE"
}

export function calculateNextLmInCircleUrl(data, lmKey) {
    return validateUrl(addLocalIfNeeded(data, data.nextLm["lmUrl"] + getLmCircleParams(data, lmKey)))
}


export function registerClick(data, buttonId, destination, destinationType) {
    logCounter("ButtonClicked:" + data.prevViewId + ":" + buttonId + "->" + destination,
        {
            aLocationType: data.viewId,
            aLocation: data.viewType,
            bActionType: "OUT",
            bAction: "Click",
            cDestinationType: destinationType,
            cDestination: destination,
            zType: "PageTraffic",
            value: 1
        }
    )
}
export function calcNameOfConcert(data) {
    return getImpl(data.currentPathObj.circle.concertObj, ["name"])
}

export function calcWhere(data) {
    return data.whereLoc
}

export function calcMotivationForNextLm(data) {
    return data.nextLm["motivation"]
}

export function calcNextLmButtonName(data) {
    return data.nextLm["buttonName"]
}

export function calcNectLmUrl(data) {
    return data.nextLmUrl
}
function calculateNextLmInCircle(profile, currentLmKey) {
    if (profile === undefined)
        throw Error("Seems profile is empty")
    if (profile.firstEntryPath === undefined)
        throw Error("Seems profile is not initialized")
    let circle = lgSetup.circles[profile.firstEntryPath.circleKey]
    if (circle === undefined)
        throw Error("Invalid circle:" + profile.firstEntryPath.circleKey)
    let seq = circle.sequences[profile.firstEntryPath.lmKey]
    if (seq === undefined)
        seq = circle.sequences["ANY"]
    if (seq === undefined)
        throw Error("Sequence not found for lm:" + profile.firstEntryPath.lmKey)
    let first = undefined
    let exit = false
    let next = undefined
    for (let l in seq) {
        if (first === undefined)
            first = l
        if (exit) {
            next = l
            break
        }
        if (l === currentLmKey) {
            exit = true
        }
    }
    if (next === undefined)
        next = first
    return next
}

function validateUrl(url) {
    if (!url.includes("http"))
        throw Error("Invalid URL: http" + url)
    if (url.includes("/undefined"))
        throw Error("Invalid URL: undefined" + url)
    return url;
}
function addLocalIfNeeded(data, url) {
    if (window.location.hostname === "localhost")
        url = url + "&local=true"
    if (data.viewId !==undefined)
        url = url + "&prevViewId=" + data.viewId
    if (data.viewType !==undefined)
        url = url + "&prevViewType=" + data.viewType
    return url
}
function getCommonParams(data) {
    return "?" + calcUtmString(data) +
        ((data.abTest1 !== undefined)?"&abTest1=" + data.abTest1:"") +
        ((data.abTest2 !== undefined)?"&abTest1=" + data.abTest2:"") +
        ((data.abTest2 !== undefined)?"&abTest1=" + data.abTest3:"") +
        ((data.cmpCode !== undefined)?"&cmp=" + data.cmpCode:"") +
        ((data.geoCode !== undefined)?"&geo=" + data.geoCode:"") +
        ((data.setFocusCode !== undefined)?"&setFocusCode=" + data.setFocusCode:"") +
        ((data.cmpVersion !== undefined)?"&cmpVersion=" + data.cmpVersion:"") +
        ((data.setVersion !== undefined)?"&setVersion=" + data.setVersion:"") +
        ((data.currentPath !== undefined && data.currentPath.adKey !== undefined)?"&adKey=" + data.currentPath.adKey:"")


}
export function calculateLeadGenerationUrl(data)
{
    let url
    if (window.location.hostname === "localhost")
        url = "http://localhost:3000"
    else
        url = "https://pay.duoclassico.eu"
    let url1 = url + (lgSetup.concerts[data.cmp.concert]["invitationUrl"]) + "&" +
        getCommonParams(data).substring(1) + "&action=LEADGEN"
    return validateUrl(addLocalIfNeeded(data, url1))
}
export function calculateFullInfoUrl(data)
{
    return validateUrl(addLocalIfNeeded(data, lgSetup.concerts[data.cmp.concert]["homepageUrl"] +
        getCommonParams(data) + "&action=FULLINFO"))
}
export function calculateConcertFullInfoUrl(data)
{
    return validateUrl(addLocalIfNeeded(data, lgSetup.products[data.productCode]["homepageUrl"] +
        getCommonParams(data)))
}

export async function calcWhereByRegion(regionKey) {
    return await calculateDistances(regionKey).then((data) => {
            let ret = ""
            let i = 0
            Object.keys(data.pointsSorted).forEach((cityId) => {
                let city = lgSetup.cities[data.pointsSorted[cityId].cityKey]
                let translate = getImpl(city, ["name#where"])
                if (ret !== "")
                {
                    if (i === data.pointsSorted.length - 1)
                        ret = ret + " и "
                    else
                        ret = ret + ", "
                }
                ret = ret + translate
                i++
            })
            return ret
        }
    )
}

export function calculateShortPageUrlNew(data) {
    return validateUrl(addLocalIfNeeded(data, lgSetup["concerts"][data.cmp["concert"]]["shortPageUrl"] +
        getCommonParams(data) + "&action=HOMESHORT"))

}
export function calculateShortPageUrlLRRH(data) {
    return validateUrl(addLocalIfNeeded(data, lgSetup["concerts"][data.cmp["concert"]]["shortPageUrl"] +
        getCommonParams(data)))

}

export function calculateShortPageToLmUrl(data, lmKey) {
    return validateUrl(addLocalIfNeeded(data, getImpl(lgSetup["lms"][lmKey],["lmUrl"]) +
        getLmCircleParams(data,lmKey)))
}
export function getLmByAdInCmp(adKey) {
    for(let circleKey in lgSetup["circles"]){
        let circle = lgSetup["circles"][circleKey]
        for(let  lmKey in circle["lms"]) {
            let letLmRef = circle["lms"][lmKey]
            for(let adsKey in letLmRef) {
                if (adsKey === adKey)
                    return {"adKey": adKey,"lmKey":lmKey,"circleKey":circleKey}
            }
        }
    }
    throw Error("LM not found for ads:" + adKey)

}
